document.addEventListener("TextEditorLoaded", async () => {
    const container = document.querySelector("#postTags");
    const input = document.querySelector("#tagInput");
    const dropdownMenu = document.querySelector("#dropdownMenuTag");
    dropdownMenu.classList.add("dropdown-menu", "mt-1");
    dropdownMenu.style.display = "none";

    let activeIndex = -1;

    function debounce(func, timeout = 200) {
        let timer;
        return (...args) => {
            clearTimeout(timer);
            timer = setTimeout(() => { func.apply(this, args); }, timeout);
        };
    }

    async function updateTopicSuggestions(term) {
        if (term.length > 0) {
            const topics = await fetchTagsByPartialName(term);
            devtricker_displaySuggestions(topics);
        } else {
            dropdownMenu.style.display = 'none';
            dropdownMenu.innerHTML = '';
        }
    }

    const debouncedUpdateSuggestions = debounce(updateTopicSuggestions);

    input.addEventListener("input", () => {
        const inputValue = input.value.toLowerCase();
        debouncedUpdateSuggestions(inputValue);
    });

    input.addEventListener("keydown", (event) => {
        const items = Array.from(dropdownMenu.getElementsByClassName("dropdown-item"));
        const maxIndex = items.length - 1;

        if (event.key === "ArrowDown") {
            event.preventDefault();
            activeIndex = (activeIndex < maxIndex) ? activeIndex + 1 : 0;
        } else if (event.key === "ArrowUp") {
            event.preventDefault();
            activeIndex = (activeIndex > 0) ? activeIndex - 1 : maxIndex;
        } else if (event.key === "Enter") {
            event.preventDefault();
            if (activeIndex >= 0 && items[activeIndex]) {
                input.value = items[activeIndex].textContent;
                dropdownMenu.style.display = "none";
                devtricker_addTopicToEditor(input.value);
            } else {
                devtricker_addTopicToEditor(input.value);
            }
            input.value = "";
            input.placeholder = "Add another topic...";
        } else if (event.key === ",") {
            event.preventDefault();

            dropdownMenu.style.display = "none";
            devtricker_addTopicToEditor(input.value);
            input.value = "";
        } else if (event.key === "Backspace" && input.value === "") {
            event.preventDefault();
            let lastTopic = document.querySelector(".topic-item:last-child");
            if (lastTopic && document.activeElement === input) {
                lastTopic.focus();
                let closeBtn = lastTopic.querySelector(".close");
                closeBtn.focus();
            } else if (document.activeElement.className.includes("close")) {
                document.activeElement.click();
            }
        }

        items.forEach(item => item.classList.remove("active"));
        if (items && activeIndex !== -1) {
            items[activeIndex].classList.add("active");
            items[activeIndex].scrollIntoView({ block: "nearest", inline: "start" });
        }
    });

    // Hide dropdown when clicking outside
    document.addEventListener("click", (event) => {
        if (container && dropdownMenu && !container.contains(event.target)) {
            dropdownMenu.style.display = "none";
        }
    });
});



function devtricker_displaySuggestions(topics) {

    const dropdownMenu = document.querySelector("#dropdownMenuTag");
    const input = document.querySelector("#tagInput");

    dropdownMenu.innerHTML = '';
    activeIndex = -1;
    if (topics && topics.length > 0) {
        dropdownMenu.style.display = 'block';
        dropdownMenu.classList.add("cursor-pointer");

        topics.forEach((topic, index) => {
            const span = document.createElement("span");
            span.classList.add("cursor-pointer");
            span.className = "dropdown-item";
            span.textContent = topic.name;
            span.setAttribute("data-id", topic.id);

            span.addEventListener("click", (event) => {

                event.preventDefault();
                dropdownMenu.style.display = "none";
                input.focus();
                devtricker_addTopicToEditor(topic.name, topic.id);
                input.value = "";
                activeIndex = -1;

            });
            dropdownMenu.appendChild(span);
        });
    } else {
        dropdownMenu.style.display = 'none';
    }
}

function activateInputTag() {
    const tags = document.querySelectorAll("#postTags .topic-item");
    const input = document.querySelector("#tagInput");

    if (input) {
        if (tags.length >= 5) {
            input.setAttribute("disabled", true);
        } else {
            input.removeAttribute("disabled");
        }
    }
}

function devtricker_addTopicToEditor(topic, id) {
    const container = document.querySelector("#postTags");
    const inputGroup = document.querySelector("#postTags .input-group");

    const existingTopics = container.querySelectorAll(".topic-item span");
    const isTopicPresent = Array.from(existingTopics).some(span => span.textContent.trim() === topic.trim());

    if (isTopicPresent) {
        return;
    }

    const topicDisplay = document.createElement("div");
    topicDisplay.classList.add("topic-item", "rounded-pill", "btn", "mt-2", "me-2", "d-flex-middle", "d-inline-flex");
    topicDisplay.style.backgroundColor = "rgb(240, 240, 240)";

    const span = document.createElement("span");
    span.textContent = topic;
    topicDisplay.appendChild(span);

    const closeButton = document.createElement("button");
    closeButton.textContent = "×";
    closeButton.classList.add("close", "btn", "btn-sm", "d-inline-flex", "d-flex-middle");
    closeButton.onclick = function () {
        topicDisplay.remove();
        activateInputTag();
    };

    topicDisplay.appendChild(closeButton);

    if (id !== undefined && id !== null) {
        topicDisplay.setAttribute("data-id", id);
    }

    container.insertBefore(topicDisplay, inputGroup);

    activateInputTag();
}

document.addEventListener("DOMContentLoaded", () => {
    const saveTagsButton = document.getElementById("saveTagsButton");
    const modalElement = document.getElementById('edit-tags-modal');

    if (modalElement) {
        const bootstrapModal = new bootstrap.Modal(modalElement);

        if (saveTagsButton) {
            saveTagsButton.addEventListener("click", async () => {

                saveTagsButton.innerHTML = `<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Saving...`;

                const path = window.location.pathname;
                const segments = path.split('/');
                let postId = segments[2] || 0;

                const tagElements = document.querySelectorAll('#postTags .topic-item');
                const tags = Array.from(tagElements).map(tagEl => {
                    const tagName = tagEl.querySelector("span").innerText.trim();
                    return tagName;
                });

                try {
                    await devtricker_ajax_update_post_tags(postId, tags);

                    saveTagsButton.innerHTML = '<span class="fw-semibold">Save</span>';
                    bootstrapModal.hide();

                    devtricker_contentWrapperToast(devtricker_createSuccessToast("Topics Updated.", 'top', 68));
                } catch (error) {

                    saveTagsButton.innerHTML = '<span class="fw-semibold">Save</span>';
                    console.error("Failed to save tags:", error);
                }
            });
        }
    }
});